<app-dialog>
  <div image>
    <mat-icon svgIcon="people-group"></mat-icon>
  </div>
  <div icon>
    <mat-icon svgIcon="east" class="east"></mat-icon>
  </div>
</app-dialog>